import React from 'react';
import API from "../apis/API";

export default async function getGroupOptionsDetailed() {
    let {data} = await API.sots.index();

    if (!data?.length) return;

    let formattedOptions = []
    for (let option of data)
    {
        formattedOptions.push({
            slug: option.slug,
            programe: option.programe,
            mode: option.mode,
            academic_year: option.academic_year,
            group_name: option.group_name
        })
    }

    return formattedOptions;
};
